/**
 * Centralized Google Tag Manager (GTM) tracking mixin
 *
 * We validate if this.gtm? as the plugin may not be loaded
 *
 * @link https://www.npmjs.com/package/@gtm-support/vue-gtm
 */

import { useLocalStorage } from "@vueuse/core"

export default {
    methods: {
        /**
         * First open is really supposed to be the first time ever opening the app.
         *
         * This method tracks the first landing event for the user using local storage.
         */
        trackFirstLanding(): void {
            const now          = (new Date()).toISOString()
            const firstLanding = useLocalStorage('firstLanding', now)
            if (firstLanding.value === now) {
                firstLanding.value = now
                this.$gtm?.trackEvent({
                    action:      'FirstLanding',
                    pageUrl:    this.$route.fullPath,
                    deviceType: this.smAndDown ? 'mobile' : 'desktop',
                    value:      now,
                })
            }
        },

        /**
         * Sign up is when they actually sign up to create an account.
         */
        trackSignUp(phoneNumber): void {
            this.$gtm?.trackEvent({
                action:    'SignUp',
                pageUrl:    this.$route.fullPath,
                deviceType: this.smAndDown ? 'mobile' : 'desktop',
                value:      phoneNumber,
            })
        },

        /**
         * Just right after confirming the payment was confirmed.
         */
        trackPaymentConfirmation(user): void {
            this.$gtm?.trackEvent({
                action:     'PaymentConfirmation',
                pageUrl:    this.$route.fullPath,
                deviceType: this.smAndDown ? 'mobile' : 'desktop',
                value:      user.account.current_subscription,
            })
        }
    }
}